import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { getPageSuggestions, type PageSuggestion } from '../utils/page-suggestions';

export function usePageContext(): { suggestions: PageSuggestion[] } {
  const { pathname } = useLocation();
  const suggestions = useMemo(() => getPageSuggestions(pathname), [pathname]);
  return { suggestions };
}
